import { BasketUnavailableStore } from '@/store/basket/basket.types'

export const DEFAULT_BASKET_UNAVAILABLE_STATE: BasketUnavailableStore = {
  unavailable_product_ids: [],
  price_changed_products: [],
  id_changed_products: [],
  changed_delivery_cost: null,
}
